import {
  SET_SORT_METHOD,
  SET_SELECTED_PLACE_ID,
  SET_LIMIT_AND_PAGE,
  SET_LAST_PAGE,
  SET_THEME_CATEGORIES,
  FILTER_CARD_BY_SEARCH_TERM,
  CLEAR_THEME_CONFIGS,
} from '../actions/types';

import { initialLimit } from '../../constants/limits';

const INITIAL_STATE = {
  id: null,
  lodges: {
    sortBy: 'none',
    sortOrder: 'none',
    searchTerm: '',
    limit: initialLimit,
    page: 1,
    categories: 'all',
    isLastPage: false,
  },
  sightings: {
    sortBy: 'none',
    sortOrder: 'none',
    searchTerm: '',
    limit: initialLimit,
    page: 1,
    categories: 'all',
    isLastPage: false,
  },
  attractions: {
    sortBy: 'none',
    sortOrder: 'none',
    searchTerm: '',
    limit: initialLimit,
    page: 1,
    categories: 'all',
    isLastPage: false,
  },
  sidetrips: {
    sortBy: 'none',
    sortOrder: 'none',
    searchTerm: '',
    limit: initialLimit,
    page: 1,
    categories: 'all',
    isLastPage: false,
  },
  places: {
    sortBy: 'none',
    sortOrder: 'none',
    searchTerm: '',
    limit: initialLimit,
    page: 1,
    categories: 'all',
    isLastPage: false,
  },
  flights: {
    sortBy: 'none',
    sortOrder: 'none',
    searchTerm: '',
    limit: initialLimit,
    page: 1,
    categories: 'all',
    isLastPage: false,
  },
};

export default (state = INITIAL_STATE, action) => {
  const { theme, sortBy, sortOrder, id, limit, page, categories, searchTerm } = action;
  switch (action.type) {
    case SET_SORT_METHOD:
      return {
        ...state,
        [theme]: {
          ...state[theme],
          sortBy,
          sortOrder,
        },
      };
    case SET_SELECTED_PLACE_ID:
      return {
        ...state,
        id,
      };
    case SET_LIMIT_AND_PAGE:
      return {
        ...state,
        [theme]: {
          ...state[theme],
          isLastPage: false,
          limit,
          page,
        },
      };
    case SET_LAST_PAGE:
      return {
        ...state,
        [theme]: {
          ...state[theme],
          isLastPage: true,
        },
      };
    case SET_THEME_CATEGORIES:
      return {
        ...state,
        [theme]: {
          ...state[theme],
          isLastPage: false,
          categories,
          limit: initialLimit,
          page: 1,
        },
      };
    case FILTER_CARD_BY_SEARCH_TERM:
      return {
        ...state,
        [theme]: {
          ...state[theme],
          isLastPage: false,
          searchTerm,
          limit: initialLimit,
          page: 1,
        },
      };
    case CLEAR_THEME_CONFIGS:
      return {
        ...state,
        [theme]: {
          ...state[theme],
          sortBy: 'none',
          sortOrder: 'none',
          searchTerm: '',
          limit: initialLimit,
          page: 1,
          categories: 'all',
          isLastPage: false,
        },
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/selectedPlaceReducer.js